// TelcoTrack — Google Shared Drive pro dokumenty zařízení.
// Kořen (DEV): https://drive.google.com/drive/folders/0AIlpeq7P4JrVUk9PVA
//
// Struktura:
//   {root} / {kategorie} / {podkategorie…} / {název} — {device_code} / soubory

export const EQUIPMENT_DRIVE = {
  /** Kořen sdíleného disku Zařízení. */
  rootFolderId: '0AIlpeq7P4JrVUk9PVA',
  /** Shared Drive id pro Drive API (u tohoto disku = rootFolderId). */
  sharedDriveId: '0AIlpeq7P4JrVUk9PVA',
  /** Složka, když zařízení nemá kategorii. */
  uncategorizedSegment: 'Bez_kategorie',
} as const;

/** Název listové složky zařízení (parita HR `{Příjmení} {Jméno} — {email}`). */
export function equipmentDriveFolderName(name: string, deviceCode: string): string {
  const code = deviceCode.trim();
  const label = name.trim() || code || 'Zařízení';
  if (code && label !== code) return `${label} — ${code}`;
  return label;
}

export function equipmentDriveFolderWebUrl(folderId: string): string {
  return `https://drive.google.com/drive/folders/${encodeURIComponent(folderId)}`;
}

/**
 * Rozdělí breadcrumb kategorie (`A / B / C`) na segmenty složek.
 * Nepoužívá sanitize — volající použije `sanitizeDriveEntryName`.
 */
export function equipmentDriveCategorySegmentsFromLabel(categoryLabel: string | null | undefined): string[] {
  const raw = (categoryLabel ?? '').trim();
  if (!raw) return [];
  return raw
    .split(/\s*\/\s*/)
    .map((s) => s.trim())
    .filter(Boolean);
}
